import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

/**
 * DREInfoCards
 * Cards informativos no rodapé do DRE:
 * "Dica de Performance" e "Entendendo seu DRE".
 */
const DREInfoCards = () => (
    <Row className="g-3 mt-3">
        {/* Dica de Performance */}
        <Col md={4}>
            <Card
                className="border-0 h-100"
                style={{
                    background: "linear-gradient(135deg, #37474f 0%, #455a64 100%)",
                    color: "#fff",
                }}
            >
                <CardBody className="d-flex align-items-start gap-3 p-4">
                    <i className="mdi mdi-lightbulb-on-outline text-white" style={{ fontSize: "1.8rem", marginTop: "2px" }} />
                    <div>
                        <h6 className="mb-1 fw-bold" style={{ fontSize: "0.85rem" }}>Dica de Performance</h6>
                        <p className="mb-0" style={{ fontSize: "0.78rem", opacity: 0.85 }}>
                            Acompanhe a Margem Líquida para garantir a saúde do negócio.
                            Uma margem acima de 20% é considerada saudável.
                        </p>
                    </div>
                </CardBody>
            </Card>
        </Col>

        {/* Entendendo seu DRE */}
        <Col md={8}>
            <Card className="border-0 shadow-sm h-100">
                <CardBody className="p-4">
                    <h6 className="fw-bold mb-2" style={{ fontSize: "0.85rem", color: "#37474f" }}>
                        Entendendo seu DRE
                    </h6>
                    <p className="mb-0 text-muted" style={{ fontSize: "0.82rem", lineHeight: "1.6" }}>
                        Este relatório agrupa todas as suas <strong>Receitas Operacionais</strong> e
                        desconta as <strong>Despesas e Custos</strong> do período.
                        Diferente do Fluxo de Caixa, o DRE foca no quanto sobrou "em mãos"
                        após todos os compromissos, servindo de bússola para sua rentabilidade.
                    </p>
                </CardBody>
            </Card>
        </Col>
    </Row>
);

export default DREInfoCards;
